import { createFileRoute } from '@tanstack/react-router';
import ClientesPageComponent from './-component';

export const Route = createFileRoute(
  '/__authenticated/comercial/produto/clientes/',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <ClientesPageComponent />;
}
